import _ from 'lodash';
import moment from 'moment';

import { Frequencies, Routes, Sources, StatusesConfig } from './constants';

export const getStatusById = (id) => _.find(StatusesConfig, (status) => status.id === id);

export const getSourceById = (id) => _.find(Sources, (source) => source.value === id);

export const getRouteById = (id) => _.find(Routes, (route) => route.value === id);

export const getFrequencyById = (id) => _.find(Frequencies, (fr) => fr.value === id);

export const isManuallyCreated = (id) =>
  _.find(Sources, (source) => source.value === id)?.isSelectable === true;

export const getDuration = (duration, filledDate, endDate) => {
  // Handle the case where a duration value is passed
  if (duration) {
    const match = duration.match(/(\d+)/);
    const value = match ? parseInt(match[0], 10) : null;

    const unitMatch = duration.match(/[a-zA-Z]/);
    const unit = unitMatch ? unitMatch[0] : null;

    let unitFullForm;
    switch (unit) {
      case 'd':
        unitFullForm = 'days';
        break;
      case 'm':
        unitFullForm = 'months';
        break;
      default:
        unitFullForm = '';
    }

    // Return the formatted string (e.g., '90 days' or '2 months')
    return `${value} ${unitFullForm}`;
  }

  if (filledDate && endDate) {
    const start = moment(filledDate, 'YYYY-MM-DD');
    const end = moment(endDate, 'YYYY-MM-DD');

    const differenceInDays = end.diff(start, 'days');
    return `${differenceInDays} days`;
  }

  return '-';
};
